import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3"
import Button from "../../../common/Button"
import { useState } from "react"

export default function EditDocument({document,setIsEditingHandler, isEditing}) {

    const [isLoading, setIsLoading] = useState(false)

    const editDocumentHandler = () => {
        if (setIsEditingHandler) {
            setIsEditingHandler(true)
        }
    }

    const updateDocumentHandler = () => {
        if (setIsEditingHandler) {
            setIsEditingHandler(false)
        }
    }


    return <>
        {!isEditing && <BodySimpleModalV3 message={'Edit document'}>
            <Button btnStyle={'btn_simple'} click={editDocumentHandler} isLoading={isLoading} loaderType={'dark'}><i className="ti ti-pencil"></i></Button>
        </BodySimpleModalV3>}
        {isEditing && <BodySimpleModalV3 message={'Complete editing'}>
            <Button btnStyle={'btn_simple'} click={updateDocumentHandler} isLoading={isLoading} loaderType={'dark'}><i className="ti ti-square-rounded-check"></i></Button>
        </BodySimpleModalV3>}
    </>
}